<se-fe-page>
  <se-fe-header
    seFePageHeader
    seFeDataTitle="Household Invite (Persona Picker)"
    seFeDataSubtitle="Card to invite guardians during Persona Picker"
    size="750">
  </se-fe-header>

  <div seFePageContent>
    <se-fe-card>
      <se-fe-card-header
        seFeDataTitle="When to use"
      ></se-fe-card-header>
      <se-fe-card-content>
        <p>Use in Persona Picker Only</p>
      </se-fe-card-content>
    </se-fe-card>

    <se-fe-card>
      <se-fe-card-header seFeDataTitle="Example Code"></se-fe-card-header>
      <se-fe-card-content>
        <se-po-household-invite-example></se-po-household-invite-example>
      </se-fe-card-content>
    </se-fe-card>

  </div>
</se-fe-page>
